import React from "react";
import { Button, Stack, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
import Img1 from "../section2Image.png";
import Img2 from "../main2.png";
import { useNavigate } from "react-router-dom";

const IntroTextSlider = () => {
  const navigate = useNavigate();
  const handleLoginClick = () => {
    navigate("/login");
  };
  return (
    <>
      <Stack sx={{}}>
        <Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: {
                xs: "20px",
                sm: "28px",
                md: "12px",
                lg: "12px",
                xl: "12px",
              },
              paddingTop: {
                xs: "20px",
                sm: "28px",
                md: "40px",
                lg: "64px",
                xl: "64px",
              },
              // border: "2px solid red",
            }}
          >
            <Stack
              sx={{
                fontSize: {
                  xs: "20px",
                  sm: "26px",
                  md: "30px",
                  lg: "34px",
                },
                color: "#054E91",
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 600,
                letterSpacing: "0.5px",
                textAlign: "left",
                width: {
                  xl: "70%",
                  lg: "79%",
                  md: "90%",
                  sm: "76%",
                  xs: "92%",
                },
                display: {
                  xs: "flex",
                  sm: "flex",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
                textAlign: "left",
                // border: "1px solid green",
                flexDirection: "row",
                marginBottom: { xl: "0px", lg: "12px", md: "8px", xs: "0px" },
              }}
            >
              <Stack
                sx={{
                  // border: "1px solid red",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stack
                  sx={{
                    width: { xl: "6px", lg: "6px", xs: "4px" },
                    height: { xs: "20px", sm: "36px", md: "30px" },
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    border: "1px solid #054e92",
                    backgroundColor: "#054e92",
                    marginRight: {
                      xs: "8px",
                      sm: "8px",
                      md: "8px",
                      lg: "12px",
                      xl: "12px",
                    },
                    borderTopRightRadius: "8px", // Adjust the value as needed
                    borderBottomRightRadius: "8px", // Adjust the value as needed
                  }}
                >
                  <h4 style={{ color: "white" }}>{""}</h4>
                </Stack>
              </Stack>
              <Stack
                sx={{
                  display: {
                    xl: "flex",
                    lg: "none",
                    md: "flex",
                    sm: "none",
                    xs: "none",
                  },
                }}
              >
                Be where your customers are- on WhatsApp
              </Stack>

              <Stack
                sx={{
                  display: {
                    xl: "none",
                    lg: "flex",
                    md: "none",
                    sm: "flex",
                    xs: "none",
                  },
                }}
              >
                {/* Talk to customers where they feel comfortable - on WhatsApp */}
                Reach customers where they are- WhatsApp
              </Stack>
              <Stack
                sx={{
                  display: {
                    xl: "none",
                    lg: "none",
                    md: "none",
                    sm: "none",
                    xs: "flex",
                  },
                }}
              >
                {/* Talk to customers where they feel comfortable - on WhatsApp */}
                Reach customers on WhatsApp
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "left",
              alignItems: "center",
              // border: "2px solid green",
            }}
          >
            <Stack
              sx={{
                // border: "2px solid green",
                fontSize: {
                  xs: "16px",
                  sm: "17px",
                  md: "20px",
                },
                lineHeight: { xs: "22px", sm: 1.8, md: 1.2 },
                fontFamily: "'Roboto', sans-serif",
                color: "text.secondary",
                width: {
                  xs: "93%",
                  sm: "80%",
                  md: "90%",
                  lg: "79%",
                  xl: "70%",
                },
                // color: "#333",
                textAlign: "left",
                border: "1px solid rgb(218 233 248)",
                padding: 1,
                borderRadius: "8px",
                backgroundColor: "#fff",
                marginBottom: { xl: "0px", lg: "40px", md: "20px", xs: "24px" },
                marginTop: "-5px",
              }}
            >
              {" "}
              Sell smarter on WhatsApp-showcase catalogs, take orders, send
              updates, offer support and receive secure payments, all in one
              trusted and engaging messaging platform.
            </Stack>
          </Stack>
        </Stack>

        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            // border: "1px solid white",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid red",
              width: {
                xs: "92%",
                sm: "80%",
                md: "90%",
                lg: "79%",
                xl: "70%",
              },
              // display: "flex",
              display: "none",
              flexDirection: "row",
              justifyContent: "flex-start",
              marginTop: { xl: "12px" },
            }}
          >
            <Button
              variant="contained"
              sx={{
                // backgroundColor: "#fff",
                backgroundColor: "rgb(5, 78, 146)",
                borderColor: "rgb(5, 78, 146)",
                // color: "rgb(0, 0, 0)",
                color: "white",
                fontSize: {
                  lg: "16px",
                  xl: "16px",
                  md: "14px",
                  sm: "12px",
                  xs: "12px",
                },
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 600,
                textTransform: "none", //  prevents auto uppercase
                // ":hover": {
                //   backgroundColor: "#fff",
                // },
                "&:hover": {
                  backgroundColor: "rgb(31, 133, 192)", // Hover background
                  borderColor: "rgb(31, 133, 192)", // Hover border
                },

                // border: "2px solid red",
                marginBottom: {
                  xs: "28px",
                  sm: "28px",
                  md: "40px",
                  lg: "40px",
                  xl: "0px",
                },
                borderRadius: "8px",
              }}
              onClick={handleLoginClick}
              size="large"
            >
              Explore all use cases
            </Button>
          </Stack>
        </Stack>
      </Stack>
      {/* </motion.div> */}
    </>
  );
};

export default IntroTextSlider;
